import { createContext } from "react";

const activityContext = createContext();

export default activityContext;